module.exports = __webpack_public_path__ + "static/media/vu.859836e7.svg";